<template>
  <div style="display: flex">
    <label class="md-form-label label">
      {{ $t(label) }}
    </label>
    <md-field
      :class="[
        { 'md-valid': !errors.has(name) && touched },
        { 'md-error': errors.has(name) }
      ]"
    >
      <label>{{ $t(placeholder) }}</label>
      <md-select
        :id="name"
        :name="name"
        :data-vv-name="name"
        v-model="inputValue"
        v-validate="validationRules"
        @md-selected="updateValue"
        :multiple="multiselect"
        :disabled="disabled"
      >
        <md-option
          v-for="(item, position) in options"
          :key="position"
          :value="valueTransformation ? valueTransformation(item) : item"
        >
          {{ displayTransformation ? displayTransformation(item) : item }}
        </md-option>
      </md-select>
      <slide-y-down-transition>
        <md-icon class="error" v-show="errors.has(name)">
          close
        </md-icon>
      </slide-y-down-transition>
      <transition-group name="list" tag="p" style="margin: 0;">
        <md-icon
          key="done"
          v-if="showDoneIcon"
          style="font-size: 20px !important;"
        >
          done
        </md-icon>
        <button
          key="clear"
          v-if="inputValue !== '' && clearable"
          @click="clear"
        >
          <md-icon style="font-size: 20px !important;">
            close
          </md-icon>
        </button>
      </transition-group>
    </md-field>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: { SlideYDownTransition },
  props: {
    value: {
      type: [String, Array],
      required: true
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    multiselect: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean
    },
    placeholder: String,
    validationRules: [String, Object],
    valueTransformation: Function,
    displayTransformation: Function
  },
  data() {
    return {
      inputValue: this.value || "",
      touched: false
    };
  },
  computed: {
    showDoneIcon() {
      if (!this.touched) {
        return false;
      }

      return this.validationRules
        ? !this.errors.has(this.name)
        : this.inputValue !== "";
    }
  },
  watch: {
    inputValue() {
      this.touched = true;
    },
    value(val) {
      this.inputValue = val;
    }
  },
  methods: {
    updateValue() {
      this.$emit("input", this.inputValue);
    },
    clear() {
      this.inputValue = "";
      this.$emit("input", "");
    }
  },
  inject: {
    $validator: "$validator"
  }
};
</script>

<style>
button {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
}
.label {
  min-width: 100px !important;
  display: inline-block !important;
  text-align: right;
}
</style>
